document.addEventListener('DOMContentLoaded', () => {
    const isGermany = document.documentElement.lang === 'de-DE'
    if(!isGermany) return;

    window.addEventListener("FormClientRendered", () => {
        const form = document.querySelector('#formclient');
        const formSlider = document.querySelector('.Slider');
        const insuranceType = window.sessionStorage.getItem('Insurance_type__c');

        form.addEventListener('submit', function (event) {
            if(formSlider.classList.contains('Slider--cc__insurance-provider')){
              const insuranceProName = document.querySelector('.js-insure-provider__name');
              const insuranceProMoney = document.querySelector('.js-insure-provider__return');
        
              const { Insurance_Company__c: insuranceProvider, Insurance_type__c: insuranceType } = event.detail.leadData;
        
              const insurancesReturn = {
                statutory: {
                  Techniker: '1.465 €',
                  Barmer: '1.465 €',
                  DAK: '1.465 €',
                  AOK: '1.445 €',
                  IKK: '1.445 €',
                  Andere: '1.500 €',
                }
              }
        
              insuranceProName.innerHTML = insuranceProvider === 'Andere' ? '' : insuranceProvider;
              insuranceProMoney.innerHTML = insuranceType === 'statutory' ? insurancesReturn[insuranceType][insuranceProvider] : '3.000 €';
            }
          });
    })
}
)